module.exports = __webpack_public_path__ + "img/burger-icon-white.7513f845.svg";